import gql from 'graphql-tag';

export default gql`
  query getOffer($id: Int!) {
    getOffer(id: $id) {
      id
      shop_id
      page_builder_id
      image
      details {
        id
        title
        description
        offer_date
        cta_label
        cta_url
        meta_title
        meta_description
        meta_tags
        meta_og_title
        meta_og_description
        meta_og_url
        language_code
        order
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/graphql/offer/get.js